import iconPersonas from "../../../assets/images/efectos/personas.png";
import iconNaturaleza from "../../../assets/images/efectos/naturaleza.png";
import iconInfraestructura from "../../../assets/images/efectos/infraestructura.png";
import iconSocioeconomicos from "../../../assets/images/efectos/socioeconomicos.png";

export const EFECTO_TIPOS_CATALOGO = [
  {
    label: "Personas",
    icon: iconPersonas,
    aliases: ["personas", "persona"],
  },
  {
    label: "Naturaleza",
    icon: iconNaturaleza,
    aliases: ["naturaleza"],
  },
  {
    label: "Infraestructura",
    icon: iconInfraestructura,
    aliases: ["infraestructura"],
  },
  {
    label: "Socioeconómicos",
    icon: iconSocioeconomicos,
    aliases: ["socioeconomicos", "socio-economicos", "socio economicos"],
  },
];

function normalizeTipoKey(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .replace(/[^a-z0-9]+/g, "");
}

export function getEfectoCatalogLabel(rawTipo) {
  const raw = String(rawTipo ?? "").trim();
  if (!raw) return null;

  const key = normalizeTipoKey(raw);
  const match = EFECTO_TIPOS_CATALOGO.find((item) =>
    item.aliases.some((alias) => normalizeTipoKey(alias) === key),
  );

  return match?.label ?? null;
}

export function efectoBelongsToTipo(efecto, catalogLabel) {
  const raw = String(efecto?.tipo_efecto ?? efecto?.tipo ?? "").trim();
  return getEfectoCatalogLabel(raw) === catalogLabel;
}

export function getEfectoTiposConDatos(efectos) {
  return EFECTO_TIPOS_CATALOGO.filter((item) =>
    (efectos || []).some((efecto) => efectoBelongsToTipo(efecto, item.label)),
  );
}

export function resolveEfectoTipo(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return null;

  const key = normalizeTipoKey(raw);
  const match = EFECTO_TIPOS_CATALOGO.find((item) =>
    item.aliases.some((alias) => normalizeTipoKey(alias) === key),
  );

  if (match) {
    return { value: raw, label: match.label, icon: match.icon };
  }

  return { value: raw, label: raw, icon: null };
}
